/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { MDXProvider } from '@mdx-js/react';
import { SpotifyPlayer } from "./SpotifyPlayer";

import Header from './Header';
import './layout.scss';
import '../styles/code.scss';

const mdxComponents = { SpotifyPlayer };

const Layout = ({ children }: any) => (
  <>
  <MDXProvider components={mdxComponents}>
    <div className="ContainerMD">
      <Header />
      <div style={{ marginTop: '2rem' }}>
        <main>{children}</main>
      </div>
    </div>
  </MDXProvider>
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
